import { Button, Icons, SPACING_1, SPACING_2, Symbols } from '@mnd-frontend/ui';
import styled from 'styled-components';
import CloudinaryImage from '../../../components/CloudinaryImage';
import type { CroppingDimensions } from '../../../modules/publish/components/ImageBankPage/ImageBankEdit/index.type';
import { ImageAspectRatio } from '../constants';

const Wrapper = styled.div<{ $aspectRatio?: number }>`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  overflow: hidden;
  aspect-ratio: ${({ $aspectRatio }) =>
    $aspectRatio ? $aspectRatio : ImageAspectRatio.Standard_4_3};

  img {
    width: 100%;
    height: auto;
    align-self: center;
  }
`;

const ButtonsWrapper = styled.div`
  display: flex;
  position: absolute;
  top: ${SPACING_1};
  right: ${SPACING_1};

  > * + * {
    margin-left: ${SPACING_2};
  }
`;

interface ImageUploadPreviewProps {
  imageUrl?: string;
  cloudinaryId?: string;
  cropping?: CroppingDimensions;
  imageAlt?: string;
  aspectRatio?: number;
  deleteDisabled?: boolean;
  deleteButtonAriaLabel?: string;
  handleFileDelete?: () => void;
  handleEditCropping?: () => void;
}

const ImageUploadPreview = ({
  imageUrl,
  cloudinaryId,
  cropping,
  imageAlt,
  aspectRatio,
  deleteDisabled,
  deleteButtonAriaLabel,
  handleFileDelete,
  handleEditCropping,
}: ImageUploadPreviewProps) => (
  <Wrapper $aspectRatio={aspectRatio}>
    {(cloudinaryId && !cloudinaryId.includes('.')) || imageUrl ? (
      <CloudinaryImage
        id={cloudinaryId}
        imageUrl={imageUrl}
        cropping={cropping}
        alt={imageAlt ?? ''}
      />
    ) : (
      <Symbols.DocumentPage />
    )}
    {(handleFileDelete || handleEditCropping) && (
      <ButtonsWrapper>
        {handleEditCropping && (
          <Button
            type="button"
            configuration="toned"
            aria-label="crop"
            onClick={handleEditCropping}
            icon={
              <svg
                width="31"
                height="25"
                viewBox="0 0 31 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 7.24263L5.5 7.24263"
                  stroke="#2C3647"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M20.9853 22.7279V7.24264L10.5 7.24264"
                  stroke="#2C3647"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 18.4854L25.228 18.4853"
                  stroke="#2C3647"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.74261 2.99998L9.74261 18.4853L18.5 18.4853"
                  stroke="#2C3647"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M25 3.49998L11 17.5"
                  stroke="#2C3647"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
          />
        )}
        {handleFileDelete && (
          <Button
            type="button"
            aria-label={deleteButtonAriaLabel || 'remove-img'}
            icon={<Icons.Delete />}
            disabled={deleteDisabled}
            onClick={handleFileDelete}
          />
        )}
      </ButtonsWrapper>
    )}
  </Wrapper>
);

export default ImageUploadPreview;
